module.exports = __webpack_public_path__ + "img/category-pathogen.a1f4e8ec.svg";